import { AcceptTicketStatus } from '@/hooks/query';
import { CheckboxActiveIcon, LoadingIcon, TicketErrorLineIcon, TicketExclamationIcon, TicketSuccessLineIcon } from '@/components/icons/svg-icons';

interface ConfirmBetTicketStatusProps {
	status: AcceptTicketStatus;
	isHeader?: boolean;
}

export const ConfirmBetTicketStatus = ({
	status,
	isHeader
}: ConfirmBetTicketStatusProps) => {
	const statusIconMap = {
		waiting: <LoadingIcon />,
		waitting: <LoadingIcon />,
		running: isHeader ? <CheckboxActiveIcon /> : <TicketSuccessLineIcon />,
		reject: isHeader ? <TicketExclamationIcon /> : <TicketErrorLineIcon />
	};

	return statusIconMap[status];
};